import React from 'react';
import styled from 'styled-components';
import Box from 'ui/Box';
import { useIntl } from 'react-intl';
import TypeFilter, { TypeFilterChildProps, TypeFilterRenderProps } from './TypeFilter';

const Wrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const Type = styled.button<{ visible: boolean }>`
  position: absolute;
  opacity: 0;
  cursor: ${props => (props.visible ? 'pointer' : 'default')};
  height: 0;
  width: 0;
  margin: 0;
  appearance: none;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: ${({ theme }) => theme.space.xxxl};
  height: ${({ theme }) => theme.space.xxxl};
  margin-right: ${({ theme }) => theme.space.s};
  margin-bottom: ${({ theme }) => theme.space.s};
`;

// https://github.com/prettier/prettier/issues/4520
// prettier-ignore
const TypeDiv = styled.div<{ visible: boolean }>`
  background: ${({ theme }) => theme.colors.grey[100]};
  border-radius: 50%;
  height: ${({ theme }) => theme.space.xxxl};
  width: ${({ theme }) => theme.space.xxxl};
  transition: all 200ms ease-in-out;
  appearance: none;
  cursor: ${props => (props.visible ? 'pointer' : 'default')};
  display: inline-grid;
  justify-items: center;
  align-items: center;
  border: 2px solid white;

  &:hover,
  ${/* sc-selector */ Type}:focus ~ & {
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2),
      0 0 0 2px ${({ theme }) => theme.colors.feedback.focus};
  }

  ${/* sc-selector */ Type}[aria-selected="true"] ~ & {
    color: #fff;
    background: #000;
  }
`;

function IconTypeFilter(props: TypeFilterChildProps) {
  const { formatMessage } = useIntl();
  return (
    <TypeFilter {...props}>
      {({ onApplyFilter, isFilterVisible, options, filterState }: TypeFilterRenderProps) => {
        return (
          <Wrapper>
            {options.map(({ id, name, icon: Icon, types }) => (
              <Item key={id} onClick={() => onApplyFilter(types)}>
                <Type
                  visible={isFilterVisible}
                  aria-label={formatMessage({ id: name })}
                  data-testid={`type-filter-${id}`}
                  aria-selected={!!(filterState[id] && filterState[id].length > 0)}
                />
                <TypeDiv visible={isFilterVisible}>{Icon && <Icon />}</TypeDiv>
              </Item>
            ))}
          </Wrapper>
        );
      }}
    </TypeFilter>
  );
}

export default IconTypeFilter;
